import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "drawer"]

  connect() {
    clearTimeout(this._closeTimer)
    document.body.style.overflow = "hidden"
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.overlayTarget.classList.add("fk-sheet-overlay--open")
        this.drawerTarget.classList.add("fk-sheet--open")
      })
    })
  }

  disconnect() {
    document.body.style.overflow = ""
  }

  close() {
    clearTimeout(this._closeTimer)
    this.overlayTarget.classList.remove("fk-sheet-overlay--open")
    this.drawerTarget.classList.remove("fk-sheet--open")
    this._closeTimer = setTimeout(() => {
      const container = document.getElementById("my_tries_feedback_drawer")
      if (container) container.innerHTML = ""
    }, 400)
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
